import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import {
  WatchlistSliceType,
  ActionItemType,
  WatchlistItemRecordType,
} from './types';
import { getInitialState } from './utils';

const initialState = getInitialState();

const watchlistSlice = createAppSlice({
  name: 'watchlist',
  initialState,
  reducers: {
    setSliceData(state, action: PayloadAction<WatchlistSliceType>) {
      return {
        ...state,
        ...action.payload,
      };
    },
    addItemToSlice(
      state,
      action: PayloadAction<{
        actionItem: ActionItemType;
        records: WatchlistItemRecordType[];
      }>,
    ) {
      const {
        actionItem: { category },
        records,
      } = action.payload;
      state[category].push(...records);
    },
    removeItemFromSlice(state, action: PayloadAction<ActionItemType>) {
      const { id, category } = action.payload;
      const removeIndex = state[category].findIndex((item) => item.id === id);
      if (removeIndex !== -1) {
        state[category].splice(removeIndex, 1);
      }
    },
    watchlistReset() {
      return initialState;
    },
  },
});

export const {
  setSliceData,
  addItemToSlice,
  removeItemFromSlice,
  watchlistReset,
} = watchlistSlice.actions;
export default watchlistSlice.reducer;
